"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIZE_TO_PADDING = void 0;
exports.SIZE_TO_PADDING = {
    sm: '16px',
    md: '16px',
    lg: '16px 24px',
};
